import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {ViewSettingService} from "../main-page/view-setting-service/view-setting.service";
import {isNullOrUndefined} from "util";
import {ActivatedRoute, Router} from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";
import {DynamicStylesHelper} from "../_service/dinamic-styles.service";
import {OrganizationService} from "../_service/organization.service";
import {OrgLinks} from "../shared-module/models/org-links";

@Component({
  selector: 'app-w-main',
  templateUrl: './welcome-part.component.html',
  // styleUrls: ['./helper.css', './../../css/main.css', './../../css/common.css'],
  encapsulation: ViewEncapsulation.None

})
export class WelcomeMainComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(public viewSettingService: ViewSettingService,
              private orgService: OrganizationService,
              private route: ActivatedRoute,
              public sanitizer: DomSanitizer,
              private cdr: ChangeDetectorRef,
              private router: Router) {
    if (this.route.children.length == 0) {
      // this.router.navigate(['./login'], {relativeTo: this.route});
    }
  }

  dynamicStylesHelper: DynamicStylesHelper = new DynamicStylesHelper('login-page', ['css/login-fix.css', 'css/main.css', 'css/common.css']);

  public cssName: any = null;
  public onMainMessage = '';
  public errorMessage = '';
  public orgLinks: OrgLinks;

  ngOnInit(): void {
    this.dynamicStylesHelper.addStyles();
    this.getOrgLinks();
  }

  ngAfterViewInit(): void {
    this.initSvgAndCss();
  }

  initSvgAndCss() {
    this.viewSettingService.initStylesAndSvg().then((ukName) => {
      this.sanitizer.bypassSecurityTrustResourceUrl('css/theme-' + ukName + '.css');
    });
  }

  ngOnDestroy(): void {
    this.cdr.detach();
    if (document.body.contains(document.getElementById('svg-data'))) {
      document.body.removeChild(document.getElementById('svg-data'));
    }
    if (document.body.contains(document.getElementById('ukStyle'))) {
      document.body.removeChild(document.getElementById('ukStyle'));
    }
    // this.cdr.detectChanges();
    this.dynamicStylesHelper.clearStyles();
  }

  goToAppStore() {
    window.open(this.orgLinks.iosLink, "_blank");
  }

  goToGooglePlay() {
    window.open(this.orgLinks.androidLink, "_blank");
  }

  goToUkPage() {
    window.open(this.orgLinks.ukLink, "_blank");
  }

  private getOrgLinks() {
    this.orgService.getLinks(localStorage.getItem("organizationAlias"))
      .then((links: OrgLinks)=>{
        this.orgLinks = links;
      }, (error)=>{
      })
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/welcome-part.component.ts